import React from 'react';
import styles from './premium-bottomsheet.module.scss';
import { LikedPayedProfile, Profile } from '@/types/profile';
import { Avatar, BottomSheet, Button, Typography } from '@/ui-kit';
import { routesApp } from '@/constans/routes';
import clsx from 'clsx';
import { MagicIcon, PremiumIcon } from '@/assets/icons';
import { BadgePremium } from '../badge-premium';
import { useNavigate } from 'react-router-dom';
import badgePriority from '@/assets/images/subscription/badge-priority.svg';
import { useAuth } from '@/store/useAuth';
import { useTranslation } from 'react-i18next';

interface Props {
    photo?: string | null;
    name?: string | null;
    isPremiumModalOpen: boolean;
    setIsPremiumModalOpen: (val: boolean) => void;
}

export const PremiumBottomsheet: React.FC<Props> = ({
    photo,
    name,
    isPremiumModalOpen,
    setIsPremiumModalOpen,
}) => {
    const navigate = useNavigate();

    const userData =
        useAuth((state) => state.getUser());

    const { t } = useTranslation();
    
    return (
        <BottomSheet
            overlayClassName={styles.bottomsheetOverlay}
            isOpen={isPremiumModalOpen}
            isDeskorTop={false}
            onClose={() => setIsPremiumModalOpen(false)}>
            <div className={styles.premiumModalContent}>
                {
                    photo &&
                    <div className={styles.premiumModalContentIcon}>
                        <Avatar src={photo} size={96} />
                        <PremiumIcon
                            className={styles.premiumModalContentIconPremium}
                            width={28}
                            height={28} />
                    </div>
                }
                {
                    name &&
                    <div className={styles.premiumModalContentHeader}>
                        <Typography
                            className={styles.premiumModalContentHeaderTitle}
                            variant={'h5'}
                            fontWeight={'bold'}>
                            {t('with_premium', { name })}
                        </Typography>
                        <Typography className={styles.premiumModalContentHeaderDesc}>
                            {t('use_app_features')}
                        </Typography>
                    </div>
                }
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                }}>
                    <BadgePremium
                        className={styles.premiumBottomsheetBadge}
                        description={t('view_likes_desc')} />
                    <BadgePremium
                        className={styles.premiumBottomsheetBadge}
                        icon={badgePriority}
                        title={t('high_priority')}
                        description={t('more_users_will_see_your_profile')} />
                </div>
                {
                    userData?.is_paid ?
                        <Button
                            typeColor="orange"
                            className={styles.premiumModalContentFootnoteBtn}
                            onClick={() => setIsPremiumModalOpen(false)}>
                            {t('ok_tertiary')}
                        </Button>
                    :
                        <Button
                            className={clsx(
                                styles.premiumModalContentFootnoteBtn,
                                styles.premiumModalContentFootnoteActivateBtn
                            )}
                            onClick={() => {
                                setIsPremiumModalOpen(false)
                                navigate(routesApp.subscription)
                            }}>
                            <Typography
                                variant="h5"
                                fontWeight="semibold"
                                className={styles.premiumModalContentFootnoteActivateBtnLabel}>
                                {t('activate_premium')}
                            </Typography>
                            <MagicIcon />
                        </Button>
                }
            </div>
        </BottomSheet>
    );
};
